import firebase from "firebase/app";
import moment from "moment";
import i18n from "../i18n";

export default {
   getActualWagons(from, to, state) {
      return new Promise((resolve) => {
         if (!from || !to) resolve([]);
         let _actuals = [];
         let tsFrom = firebase.firestore.Timestamp.fromDate(moment(from).toDate());
        //let tsFrom = firebase.firestore.Timestamp.fromDate(moment("2018-11-01").toDate());  //for debug only
         let tsTo = firebase.firestore.Timestamp.fromDate(moment(to).endOf("day").toDate());

         var ref = firebase.firestore().collection("/Users")
                   .doc(state.user.uid).collection("/Actuals");
         //var ref = firebase.firestore().collection("/Actuals");
         ref.orderBy("startTime")
            .startAfter(tsFrom)
            .endBefore(tsTo)
            .limit(1000)
            .get().then(function (snap) {
               snap.forEach(function (doc) {
                  let _loadings = [];
                  if (doc.data().loadings && doc.data().loadings.length > 0) {
                     doc.data().loadings.forEach((l) => {
                        _loadings.push({
                           duration: l.duration || 0,
                           feedId: l.feedId || "",
                           status: l.lineStatus,
                           loadOrder: l.loadOrder,
                           qty: l.qty || 0,
                           qtyNeeded: l.qtyNeeded || 0,
                           startTime: l.startTime ? l.startTime.toDate() : new Date("2000-01-01"),
                           //calculated:
                           diff: l.qtyNeeded != 0 ? Math.round((l.qty - l.qtyNeeded) * 1000 / l.qtyNeeded)/10 : 0
                        });
                     });
                  }
                  let _unloadings = [];
                  if (doc.data().unloadings && doc.data().unloadings.length > 0) {
                     doc.data().unloadings.forEach((u) => {
                        _unloadings.push({
                           grpCode: u.grpCode,
                           groupId: u.groupId || "",
                           qty: u.unloadedWeight || 0,
                           qtyNeeded: u.qty || 0,
                           startTime: u.StartTime ? u.StartTime.toDate() : new Date("2000-01-01"),
                           status: u.status,
                           unloadOrder: u.unloadOrder,
                           //calculated:
                           diff: u.qty != 0 ? Math.round((u.unloadedWeight - u.qty) * 1000 / u.qty)/10 : 0
                        });
                     });
                  }
                  _actuals.push({
                     id: doc.id,
                     created: doc.data().created ? doc.data().created.toDate() : new Date("2000-01-01"),
                     duration: doc.data().duration || 0,
                     endTime: doc.data().endTime ? doc.data().endTime.toDate() : new Date("2000-01-01"),
                     planWagonId: doc.data().planWagonId || "",
                     startTime: doc.data().startTime ? doc.data().startTime.toDate() : new Date("2000-01-01"),
                     status: doc.data().status,
                     tmrCode: doc.data().tmrCode || "",
                     tmrId: doc.data().tmrId || "",
                     wagonName: doc.data().wagonName || "",
                     tmrValue: doc.data().tmrValue || 0.0,
                     tmrDryMaterial: doc.data().tmrDryMaterial || 1.0,
                     loadings: _loadings,
                     unloadings: _unloadings,
                     loadDuration: doc.data().loadDuration || 0,
                     //calculated..
                     wagonTotal: _loadings ? _loadings.reduce(function (a, b) {
                          return isNaN(Number(b["qty"])) ? a : a + Number(b["qty"]);
                        }, 0) : 0,
                     wagonPlanTotal: _loadings ? _loadings.reduce(function (a, b) {
                             return isNaN(Number(b["qtyNeeded"])) ? a : a + Number(b["qtyNeeded"]);
                           }, 0) : 0,
                     wagonTotalUnload:
                        _unloadings ? _unloadings.reduce(function (a, b) {
                           return isNaN(Number(b["qty"])) ? a : a + Number(b["qty"]);
                        }, 0) : 0,
                     // wagonDiff: this.wagonPlanTotal ?
                     //    Math.round((this.wagonPlanTotal - this.wagonTotal) * 1000 / this.wagonPlanTotal)/10 : 0

                  });
               });
               resolve(_actuals);
            });
      })
   },

   getActualDeliveries(from, to, state) {
      return new Promise((resolve) => {
         if (!from || !to) resolve([]);
         let _unloadings = [];
         let tsFrom = firebase.firestore.Timestamp.fromDate(moment(from).toDate());
         let tsTo = firebase.firestore.Timestamp.fromDate(moment(to).endOf("day").toDate());
         var ref = firebase.firestore().collection("/Users")
                   .doc(state.user.uid).collection("/Actuals");
         ref.orderBy("startTime")
            .startAfter(tsFrom)
            .endBefore(tsTo)
            .limit(1000)
            .get().then(function (snap) {
               snap.forEach(function (doc) {
                  if (doc.data().unloadings && doc.data().unloadings.length > 0) {
                     doc.data().unloadings.forEach((u) => {
                        _unloadings.push({
                           wgnId: doc.id,
                           tmrCode: doc.data().tmrCode || "",
                           tmrId: doc.data().tmrId || "",
                           grpCode: u.grpCode,
                           groupId: u.groupId || "",
                           qty: u.unloadedWeight || 0,
                           qtyNeeded: u.qty || 0,
                           startTime: u.startTime ? u.startTime.toDate() : new Date("2000-01-01"),
                           status: u.status,
                           dailyPercent: u.dailyPercent,
                           //calculated:
                           diff: u.qty != 0 ? Math.round((u.unloadedWeight - u.qty) * 1000 / u.qty)/10 : 0,
                           Group: (u.startTime ? moment(u.startTime.toDate()).format("YYYY-MM-DD") : "") + "  " + i18n.t('Group')+ ": " + u.grpCode
                        });
                     });
                  }
               });
               resolve(_unloadings);
            })
         })
   },
   getMaterialsUsed(from, to, state) {
      return new Promise((resolve) => {
         if (!from || !to) resolve([]);
         let _materials = [];
         let tsFrom = firebase.firestore.Timestamp.fromDate(moment(from).toDate());
         //let tsFrom = firebase.firestore.Timestamp.fromDate(moment("2018-11-01").toDate());  //for debug only
         let tsTo = firebase.firestore.Timestamp.fromDate(moment(to).endOf("day").toDate());
         var ref = firebase.firestore().collection("/Users")
                   .doc(state.user.uid).collection("/Actuals");
         //var ref = firebase.firestore().collection("/Actuals");
         ref.orderBy("startTime")
            .startAfter(tsFrom)
            .endBefore(tsTo)
            .limit(1000)
            .get().then(function (snap) {
               snap.forEach(function (doc) {
                  if (doc.data().loadings && doc.data().loadings.length > 0) {
                     doc.data().loadings.forEach((l) => {
                        let matIndex = _materials.findIndex((x) => x.feedId == l.feedId);
                        if ( matIndex == -1 ) {
                           let feed  =  state.Feeds.find((f) => f.Id === l.feedId );
                           matIndex =  _materials.push({feedId: l.feedId, qty: 0, dryMaterial: 0, feed: feed}) - 1;
                        }
                           _materials[matIndex].qty += l.qty;
                           _materials[matIndex].dryMaterial += (l.dryMaterial * l.qty);
                     });
                  }
               });
            })
         resolve(_materials);
      });
   },
   getGraphsData(from, state) {
      if (!from)
      from = new Date();
      from = moment(from).startOf("day").toDate();
      const to = moment(from).endOf("day").toDate();
      const tsFrom = firebase.firestore.Timestamp.fromDate(from);
      const tsTo = firebase.firestore.Timestamp.fromDate(to);
      const ref = firebase.firestore().collection("/Users")
      .doc(state.user.uid).collection("/Actuals");
      return new Promise((resolve) => {
      const data = [];
         ref.orderBy("startTime")
            .startAt(tsFrom)
            .endAt(tsTo)
            .get()
            .then(snap => {
             //console.debug("snapshot doc count:", snap.docs.length);
               let made = 0;
               let deliv = 0;
               snap.docs.forEach(doc => {
                  const w= doc.data();
                  made = w.loadings.reduce(function (a, b) {
                     return isNaN(Number(b.qty)) ? a : a + Number(b.qty);
                  }, 0);
                  deliv = w.unloadings.reduce(function (a, b) {
                     return isNaN(Number(b.unloadedWeight)) ? a : a + Number(b.unloadedWeight);
                  }, 0);
                //console.log(`entry: ${w.wagonName} Made: ${made} deliv: ${deliv}`);
                  data.push({
                     name: w.wagonName,
                     made: made,
                     delivery: deliv,
                     startDate: w.startDate,
                     tmrValue: w.tmrValue,
                     tmrDryMaterial: w.tmrDryMaterial,
                     duration: w.duration
                  })
               })
            })
         resolve(data);
      });
   },
   getTransactionLog(from, to, state) {
      return new Promise((resolve) => {
         if (!from || !to) resolve([]);
         let _trans = [];
         let tsFrom = firebase.firestore.Timestamp.fromDate(moment(from).toDate());
         let tsTo = firebase.firestore.Timestamp.fromDate(moment(to).endOf("day").toDate());
         var ref = firebase.firestore().collection("/Users")
            .doc(state.user.uid).collection("/transactions");
         ref.orderBy("transTime")
            .startAfter(tsFrom)
            .endBefore(tsTo)
            .limit(1000)
            .get().then(function (snap) {
               snap.forEach(function (snap) {
                  let doc = snap.data();
                  let feedId = doc.feedRef ? doc.feedRef.id : "__xxx__";
                  let feed = state.Feeds.find(f => f.Id == feedId);
                  if (!feed)
                     feed = state.TMRs.find(t => t.Id == feedId);
                  if (!feed)
                     feed = {};
                  let wgnNameArray = doc.refDoc ? doc.refDoc.id.split("-") : [];
                  wgnNameArray.shift();
                  _trans.push({
                     id: snap.id,
                     transNo: doc.transNo || 0,
                     materialCode: feed.code || "",
                     materialName: feed.name || "",
                     transQty: doc.transQty,
                     transTime: doc.transTime.toDate(),
                     refDoc: doc.refDoc || "",
                     wagonName: wgnNameArray.join(""),
                     transType: doc.transType || "",
                     seller: doc.seller || "",
                     driver: doc.driver || "",
                     truckNo: doc.truckNo || "",
                     reference: doc.reference || "",
                     dryMaterial: doc.dryMaterial || 0,
                     feedValue: doc.feedValue || 0
                  });
               });
            });
         resolve(_trans);
      });
   },

}